export const convertToHours = ({ years, months, days, hours, minutes }) => {
  return parseInt(years * 8760 + months * 730 + days * 24 + hours + minutes / 60, 10);
};
